import { InputAdornment, InputLabel, Select, TextField, FormControl, MenuItem } from "@mui/material";
import { SegnalazioniService } from "../../../services/controllers/segnalazioni-services/SegnalazioniService";
import { FiltroFields, FiltroRows, filtroSectionInt } from "../../../services/models/objs/filterSection";
import {useEffect, useState} from 'react';
import CustomButton from "../../../shared/atomic_components/button/CustomButton";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import EventIcon from '@mui/icons-material/Event';
import CONSTANTS from "../../../shared/utils/Constants";

const datePicker = {
    cursor: "pointer",
};

const FiltroSection = (props : any) => {
    const [fieldsFiltro, setfieldsFiltro] = useState<FiltroRows[]>(props.rows)
    const [filtroForm, setFiltroForm] = useState<{[key : string] : string}>({});
    
    let filtroChoiceLists : {[key : string] : any};

    useEffect(() => {       
        if(sessionStorage.getItem("filter")){
            let filter : string | null = sessionStorage.getItem("filter")
            if(filter != null){
                let value : {[key : string] : string} = {}
                value = JSON.parse(filter)
                setFiltroForm(value) 
            }
        }
    }, []) // [] means run only ones

    function setFilterCerca(){
        sessionStorage.setItem('filter', JSON.stringify(filtroForm))
        cercaStor()
    }


    async function cercaStor(){
        const segnalazioniService : SegnalazioniService = new SegnalazioniService();
        const response = await segnalazioniService.getFilteredListStor(filtroForm, props.user.selectedGroup);
        if(response){
            let newDate : Date
            response.elements?.forEach(element =>{
                if(element.sentDate){
                    newDate = new Date(element.sentDate)
                    element.sentDate = newDate.toLocaleDateString()
                }
                element.financialString = getInstrument(element)
            })
            props.callback(response, filtroForm);
            
        }
    }

    async function azzeraStor(){
        setFiltroForm({})
        sessionStorage.setItem('filter', JSON.stringify({}))
        const segnalazioniService : SegnalazioniService = new SegnalazioniService();
        const response = await segnalazioniService.getFilteredListStor({}, props.user.selectedGroup);
        if(response){
            let newDate : Date
            response.elements?.forEach(element =>{
                if(element.sentDate){
                    newDate = new Date(element.sentDate)
                    element.sentDate = newDate.toLocaleDateString()
                }
                element.financialString = getInstrument(element)
            })
            props.callback(response);
        }
    }

    function getInstrument(segnalazione : any) : string{
        let instrumentString = ''
        if(segnalazione.financialIntrumentCode && segnalazione.financialIntrumentCode.length>2)
            instrumentString = 'Più strumenti finanziari'
        else if(segnalazione.financialIntrumentCode.length>0){
            segnalazione.financialIntrumentCode.forEach((instr:string) => {
                if(instrumentString === '')
                    instrumentString = instr
                else 
                    instrumentString = instrumentString + ',' + instr
            });
        }
        return instrumentString
    }

    function renderForm(field : FiltroFields) {
        switch (field.type) {
            case "text":
                return renderTextForm(field)
            case "date":
                return renderDateForm(field)
            case "choice": {
                if(props.user?.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole)){
                    return renderChoiceForm(field) 
                }
                else{
                    return renderChoiceFormExternal(field) 
                }
            }         
        }
    }

    function HandleChange(event: any, field : FiltroFields) {
        const tmpFIlter : {[key : string] : any} = {}
        Object.assign(tmpFIlter, filtroForm)
        tmpFIlter[field.name] = event.target.value
        setFiltroForm(tmpFIlter)
    }

    function HandleChangeDateForm(field : FiltroFields, date: any) {
        const tmpFIlter : {[key : string] : any} = {}
        Object.assign(tmpFIlter, filtroForm)
        let dateFormatted = date?.toISOString()
        if(dateFormatted)
            dateFormatted = addHours(dateFormatted, 1).toISOString()
        tmpFIlter[field.name] = dateFormatted
        setFiltroForm(tmpFIlter)
    }

    const addHours = (date: Date, hours: number): Date => {
        const result = new Date(date);
        result.setHours(result.getHours() + hours);
        return result;
      };

    function getValue(field : FiltroFields) : string{
        if(filtroForm[field.name])
            return filtroForm[field.name]
        else
            return ""
    }

    function getDate(field : FiltroFields) {
        if (filtroForm[field.name]) {
            return new Date(filtroForm[field.name])
        }
        else
            return null
    }

    const renderTextForm = (field : FiltroFields) => {
        return <TextField
                onChange={(event => {HandleChange(event, field)})}
                fullWidth={true}
                value={getValue(field)}
                id={field.name}
                label={field.label}
            />
    }

    const renderDateForm = (field : FiltroFields) => {
        return <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'it'}>
            <MobileDatePicker
                componentsProps={{
                    actionBar: {
                        actions: ['clear','accept']
                    }
                }}
                label={field.label}
                value={getDate(field)}
                className="datePicker"
                disableHighlightToday={true}
                // inputFormat="DD/MM/YYYY"
                onChange={(date) => {
                    HandleChangeDateForm(field, date);
                }}
                renderInput={(params) => <TextField {...params}
                    required={field.required}
                    fullWidth
                    InputProps={{
                        endAdornment: <InputAdornment position="end">
                                        <EventIcon style={datePicker}/>
                                    </InputAdornment>,
                    }}/>
                }
            />
        </LocalizationProvider>
    }

    const renderChoiceForm = (field : FiltroFields) => {
        return <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">{field.required? field.label + " *" : field.label}</InputLabel>
            <Select
                value={getValue(field)}
                label={field.label}
                onChange={(event => {HandleChange(event, field)})}>
                <MenuItem key="" value="">{'-Seleziona-'}</MenuItem>
                <MenuItem  value={'STOR'}>STOR</MenuItem>
                <MenuItem  value={'Mkt Observation'}>Market Observation</MenuItem>
                <MenuItem  value={'Other Inputs'}>Altro</MenuItem>
            </Select>
        </FormControl>
    }

    const renderChoiceFormExternal = (field : FiltroFields) => {
        return <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">{field.required? field.label + " *" : field.label}</InputLabel>
            <Select
                value={getValue(field)}
                label={field.label}
                onChange={(event => {HandleChange(event, field)})}>
                <MenuItem key="" value="">{'-Seleziona-'}</MenuItem>
                <MenuItem  value={'STOR'}>STOR</MenuItem>
                <MenuItem  value={'Mkt Observation'}>Market Observation</MenuItem>
            </Select>
        </FormControl>
    }

    return (
        <div className="row card-body background-gray">
            <div className="background-white mt-3 card-body">
                <div className="row font-medium-custom text-bold">
                    <div className="col-md-12">
                        <div className="mt-2 mb-4">
                            {fieldsFiltro.map(row => {
                                return <div key={row.id} className="row mt-4">
                                    {row.fields.map(field =>{
                                        return <div key={field.name} className={"col-md-" + field.numColMd + " col-sm-12"}>
                                            {renderForm(field)}
                                        </div>})
                                    }
                                </div>})
                            }
                            <div className="col-12 mt-5 text-end">
                                <CustomButton onClick={setFilterCerca}  
                                              className="margin-right-5 col-auto"
                                              variant="contained">Filtra</CustomButton>
                                <CustomButton onClick={azzeraStor}  
                                              className="col-auto"
                                              variant="contained">Azzera Filtri</CustomButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default FiltroSection;